import { VersionNumber } from "components/VersionNumber/VersionNumber";
import React, { useEffect } from "react";
import styles from "./Splash.module.scss";
import FELogoLight from "/FELogoStackedText.png";
import FELogoDark from "/FELogoStackedWhite.png";
import { lightTheme, darkTheme } from "@factorearth/component-library";

function Splash() {
	const [logo, setLogo] = React.useState<string>(FELogoLight);
	const [background, setBackground] = React.useState<string>(lightTheme.background.primary);
	const [textColor, setTextColor] = React.useState<string>(lightTheme.text.primary);

	useEffect(() => {
		let theme = localStorage.getItem("theme") as "light" | "dark" | null | undefined;
		if (theme === null || theme === undefined) {
			localStorage.setItem("theme", "light");
			theme = "light";
		}
		setLogo(theme === "light" ? FELogoLight : FELogoDark);
		setBackground(theme === "light" ? lightTheme.background.primary : darkTheme.background.primary);
		setTextColor(theme === "light" ? lightTheme.text.primary : darkTheme.text.primary);
	}, []);

	return (
		<div className={styles.container} style={{ color: textColor, backgroundColor: background }}>
			<img src={logo} alt="FactorEarth logo" width={320} height={136} />
			{import.meta.env.VITE_APP_ENV !== "production" && `Development `}
			<VersionNumber />
			Loading...
		</div>
	);
}

export default Splash;
